import React from 'react'
import { deleteProductSolution } from '../../store/actions/index';
import DeleteModal from './DeleteModal';
import { useTranslation } from 'react-i18next';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';

const DeleteProductSolutionModal = (props) => {

  const onSubmitAction = (values) => {
    console.log('********************');
    console.log(props.formObject);
    console.log('********************');
    return deleteProductSolution(props.formObject.projectId, props.formObject.productSolutionId)
  };

  const redirectTo = () => {};
  const { t } = useTranslation();
  const ht = useCustomHtmlTranslation();

  return (
    <DeleteModal
      modalTitle={ t( 'modal.delete_product_solution.title' ) }
      onSubmitAction={onSubmitAction}
      redirectTo={redirectTo}
    >
    { ht('modal.delete_product_solution.text') }
    </DeleteModal>
  )
}

export default DeleteProductSolutionModal



// WEBPACK FOOTER //
// ./src/components/Modals/DeleteProductSolutionModal.js